import { Component, Inject } from '@angular/core';
import { ConfigService } from '@aiwyn/config';
import { AbstractModal } from '../abstract-modal/abstract-modal';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pdf-modal',
  templateUrl: './pdf-modal.component.html',
  styleUrls: ['./pdf-modal.component.scss'],
  standalone: false,
})
// PDF modal is the default option for viewing pdf. If configOption.openPdfInNewWindow = true, we will use a new browser window to view PDF
export class PdfModalComponent extends AbstractModal {

  pdfLoaded = false;

  constructor(
    public dialogRef: MatDialogRef<PdfModalComponent>,
    public configService : ConfigService,
    @Inject(MAT_DIALOG_DATA) public data: string) {
    super(dialogRef);
  }

  onClose(): void {
    this.pdfLoaded = false;
    this.dialogRef.close();
  }

  onLoad(): void {
    this.pdfLoaded = true;
  }
}
